import { render } from "./Home.vue?vue&type=template&id=352a007d&bindings={}"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script